export default __webpack_public_path__ + "static/media/ex-landing.0adc6136.jpg";